module.exports = __webpack_public_path__ + "img/symptom.2a4c9d07.png";